import styled from 'styled-components';
import COLOR from '../../../utils/colors.constants';

const Titulo = styled.div`
    font-size: 2.5rem;
    text-align: center;
    padding: 40px;
    color: ${COLOR.AZUL};
    font-weight: 600;
`;

export default Titulo;
